<button
  class="btn btn-primary btn-action mb-0"
  [ngClass]="{ 'float-right': floatRight, 'style-hover': styleHover, 'disable-outline': disableOutline }"
  [attr.id]="buttonId"
  (click)="clickEvent.emit($event)"
  [disabled]="disabled"
  [attr.routerLink]="routerLink && !disabled ? routerLink : null"
  [routerLinkActive]="'routerLinkActive'"
  [title]="title"
  [type]="buttonType"
  [class.margin-hack]="marginHack"
  [ngStyle]="buttonStyles"
  [attr.form]="formId"
>
  <i [ngClass]="'fa action-icon' + (icon ? ' fa-' + icon : '')" [ngStyle]="iconStyles" [class.font-danger]="toggledState"></i>
</button>
